import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return <LegalPage slug="terms" fallbackTitle="Terms of Service" />;
}
